import { FilterConfig } from "../../schemas";
import { partitionByActive } from "../../utils";

export function useDesktopFilters(filters: FilterConfig[]) {
  const filtersWithComputedValues = filters.map((filter) => {
    const { activeValues, inactiveValues } = partitionByActive(filter.values);
    return { ...filter, activeValues, inactiveValues };
  });

  const hasActiveFilters = filtersWithComputedValues.some(
    (filter) => filter.activeValues.length > 0 || !!filter.activeLabel,
  );

  return { filtersWithComputedValues, hasActiveFilters };
}
